import { api } from 'api/api'

export const changeUserStatus = (userId: string, activate: boolean) => () =>
  activate
    ? api.put(`/v1/users/${userId}/active`)
    : api.put(`/v1/users/${userId}/lock`)
